import React, { useRef, useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { AuthContext} from '../Context/AuthProvider';
import scrollToTop from '../functions/ScrollToTop';
import { motion } from 'framer-motion';
import axios from "axios";
import Strzalka from './Strzalka';
import { fetchSerwis } from '../Redux/Actions';
import { czyAktywnySerwis } from '../functions/utilities';

const LOGIN_URL = "/api/auth";

const Login = () => {

    const {auth, setAuth, role, setRole, setUser, setUserId, setCred} = useContext(AuthContext);

    const userRef = useRef();    
    const errRef = useRef();

    const [tooMany, setTooMany] = useState(false);
    const [wrong, setWrong] = useState(false);

    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(fetchSerwis())
    },[dispatch]);

    const serwisy = useSelector( state => state?.serwis?.data);

    useEffect( ()=> scrollToTop(), []);

    const [userName, setUserName] = useState('');
    const [pwd, setPwd] = useState('');
    const [showPwd, setShowPdw] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [capslock, setCapslock] = useState(false);

    const [czyAktywny, setCzyAktywny] = useState(false);

    const navigate = useNavigate();

    if (auth && role) {
        navigate('/');
    }

    useEffect( () => {
        const odp = czyAktywnySerwis(serwisy);
        setCzyAktywny( odp );      
    },[serwisy]);  

    useEffect(() => userRef.current.focus(), []);

    useEffect(() => setErrMsg(''), [userName], [pwd]);

    axios.defaults.withCredentials = true;

    const handleUserName = e => setUserName(e.target.value);
    const handlePwd = e => setPwd(e.target.value);

    const handleShow = () => setShowPdw( prevState => !prevState);

    useEffect( () => setWrong(false), [userName, pwd])

    const handleSubmit = async (e) => {
        e.preventDefault();
        axios.post(LOGIN_URL, {userName, pwd})
            .then(res => {
                if(res.data.login) {
                    setAuth(true);
                    setRole(res.data.role);
                    setUser(res.data.user);
                    setUserId(res.data.id_user);
                    setCred(res.data);

                    axios.post("/api/log", { id_user: res.data.id_user, akcja: "Zalogowanie" })
                        
                    if (res.data.role === "mieszkaniec") {
                        if (czyAktywny)
                            navigate('/serwis');
                        else 
                            navigate('/mieszkaniec');  
                    } else 
                        navigate('/wspolnoty');
                }
                else {
                    setWrong(true);
                }
            })
            .catch(err=> {
                console.log(err);
                if (err.response.status === 429)
                    setTooMany(true);
                axios.post("/api/log", { id_user: 0, akcja: `${userName}: ${err}` });
            });
    }

    useEffect(() => {
        const handleKeyEvent = (e) => {
          const caps = e.getModifierState && e.getModifierState('CapsLock');
          setCapslock(caps);
        };
    
        window.addEventListener('keydown', handleKeyEvent);
        window.addEventListener('keyup', handleKeyEvent);
    
        return () => {
          window.removeEventListener('keydown', handleKeyEvent);
          window.removeEventListener('keyup', handleKeyEvent);
        };
    }, []);

    const handleKeyPress = (e) => {
        const capsLockOn = e.getModifierState && e.getModifierState('CapsLock');
        setCapslock(capsLockOn);
    };

    return (
        <div className='login'>       

            <motion.section  
                className='cienie' 
                whileHover={{ scale: 1.05}} 
                transition={{duration: 0.1}}
            >
                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                {/* <h4 style={{textAlign: "center", textDecoration: "underline"}}>Obecnie trwają prace serwisowe.<br/>Zapraszamy później.</h4> */}
                <h1>Logowanie</h1>
                <form onSubmit={handleSubmit}>
                    <section className="user">
                        <label htmlFor='username'>Użytkownik</label>
                        <input 
                            type="text" 
                            id="username"
                            ref={userRef}
                            autoComplete='off'
                            onChange={handleUserName}
                            value={userName}
                            required
                            onKeyDown={handleKeyPress}
                            onKeyUp={handleKeyPress}
                            onClick={handleKeyPress}
                            // disabled
                        />
                    </section>
                    <section className='pwd'>
                        <label htmlFor='password'>Hasło</label>
                        <div className='pwd'>
                            <input 
                                type={ !showPwd ? "password" : "text"  }
                                id="password"
                                autoComplete='off'
                                onChange={handlePwd}
                                value={pwd}
                                required
                                onKeyDown={handleKeyPress}
                                onKeyUp={handleKeyPress}
                                onClick={handleKeyPress}
                                // disabled
                            />
                            { !showPwd ? ( <FontAwesomeIcon icon={faEye} className='pointer' onClick={handleShow}/> ) : (<FontAwesomeIcon icon={faEyeSlash} className='pointer' onClick={handleShow}/>) }
                        </div>
                    </section>
                    
                        <div className='capslock'>
                        { capslock && 
                           ( <span>
                                Klawisz CapsLock jest włączony
                            </span>
                            ) }
                        </div>

                        <div className='wrong'>
                        { wrong && 
                           ( <span>
                                Nieprawidłowe dane logowania.
                            </span>
                            ) }
                        </div>
                        <div className='too-many'>
                        { tooMany && 
                           ( <span>
                                Zbyt wiele prób logowania.<br/>Spróbuj ponownie za 10 minut.
                            </span>
                            ) }
                        </div>
                    
                    <div className='button'>
                        <button 
                            // disabled
                        >
                            Zaloguj
                         </button>
                    </div>                    
                </form>
            </motion.section>
            <Strzalka/>
        </div>
    )
}

export default Login;